// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1TZ_3","inputWrap":"styles_inputWrap__1ijw0","input":"styles_input__2Nso5"};